export const POLICY_CONFIG_LIST = "POLICY_CONFIG_LIST";
